import { module } from 'angular';
import { ngCustomSelectDirective } from './ng.custom.select/ng.custom.select.directive';
import { ngMultiSelectDirective } from './ng.multi.select/ng.multi.select.directive';
import { ngStatusInputDirective } from './ng.status.input/ng.status.input.directive';
import { ngDropdownMenu } from './ng.dropdown.menu/ng.dropdown.menu';
import { gmcCollapseDirective } from './gmc-collapse/gmc-collapse.directive';
import { gmcOnloadDirective } from './gmc-onload/gmc-onload';
import { SwiperModule } from './swiper/swiper.module';
import { GmcRecaptchaModule } from './gmc-recaptcha/gmc-recaptcha.module';
import { gmcScollOffsetDirective } from './gmc-scroll-spy/gmc-scroll-offset.directive';
import { gmcFilereaderDirective } from './gmc-filereader/gmc-filereader.directive';
import { ValidatorDirectivesModule } from './validator-directives/validator-directives.module';
import { InputEventModule } from './input-event/input-event.module';
import { GmcClipboardModule } from './gmc-clipboard/gmc-clipboard.module';
import { UiRouterTitleModule } from './ui-router-title/ui-router-title.module';
import { EventOnloadModule } from './event-onload/event-onload.module';
import { buttonDisabled } from './gmc-button-disable/gmc-button-disable.directive';
import { imageZoom } from './image-zoom/image-zoom.directive';

export const SharedDirectivesModule = module('shared.directives', [
  SwiperModule.name,
  GmcRecaptchaModule.name,
  ValidatorDirectivesModule.name,
  InputEventModule.name,
  GmcClipboardModule,
  UiRouterTitleModule,
  EventOnloadModule
])
  .directive('gmcCollapse', gmcCollapseDirective)
  .directive('gmcOnload', gmcOnloadDirective)
  .directive('gmcScrollOffset', gmcScollOffsetDirective)
  .directive('ngCustomSelect', ngCustomSelectDirective)
  .directive('ngMultiSelect', ngMultiSelectDirective)
  .directive('ngStatusInput', ngStatusInputDirective)
  .directive('ngDropdownMenu', ngDropdownMenu)
  .directive('btnPlanDisabled', buttonDisabled)
  .directive('gmcFilereader', gmcFilereaderDirective)
  .directive('imageZoom', imageZoom);



// WEBPACK FOOTER //
// ./app/shared/directives/shared-directives.module.ts